// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"13853aae","422":"a36c7059","455":"5ab98cc1"}[chunkId] + ".chunk.js";
};